
import { lang, servicelocations, getFloors } from '~/data-utils';
import { typeToServiceType } from './facility-types';

import Facility, {
  serviceLocationToFacility,
  serviceLocationToSearchItem } from './facility-item';


export default class InhouseFacilitiesProvider {

  constructor (Wayfinding) {
    this.Wayfinding = Wayfinding;
    const serviceLocations = servicelocations();
    const floors = getFloors();

    this.facilities = serviceLocations.map(serviceLocationToFacility(
      floors
    ));

    this.facilitiesMap = new Map();
    this.searchItemMap = InhouseFacilitiesProvider.toSearchItemMap(
      serviceLocations
    );
    this.searchItems = Array.from(this.searchItemMap.values());

    this.types = InhouseFacilitiesProvider.getDistinctTypes(this.facilities);
    this.floorsByType = InhouseFacilitiesProvider.getDistinctFloorByTypes(this.facilities);
    this.closest = this._getClosestByTypes();

    this.closest.then(closest => {
      this.genericFacilities = new Map(
        closest.map(({ id, ref }) => {
          return [id, new Facility(ref.type, id)];
        })
      );
    });
  }

  getClosest () {
    return this.closest;
  }

  getFacility (id) {
    const key = `${lang()}:${id}`;
    if (!this.facilitiesMap.has(key)) {

      const generic = this.genericFacilities.get(id);

      const { type } = generic;
      const floorIds = this.floorsByType[type];
      const floors = getFloors().filter(({id}) => floorIds.includes(id));

      const facility = new Facility(
        type,
        id,
        floors.map(x => x.description).join(', ')
      );
      this.facilitiesMap.set(key, facility);
    }
    return this.facilitiesMap.get(key);
  }

  // toSearchItemMap :: [ServiceLocation] -> Map [String, SearchItem]
  static toSearchItemMap (serviceLocations) {
    return serviceLocations.reduce((acc, location) => {
      const item = serviceLocationToSearchItem(location);
      if (item) {
        acc.set(item.id, item);
      }
      return acc;
    }, new Map());
  }

  static getDistinctTypes (facilities) {
    const set = facilities.reduce((acc, { type }) => {
      const add = type && !/escalator|stairs/.test(type);
      add && acc.add(type);
      return acc;
    }, new Set());
    return Array.from(set);
  }

  static getDistinctFloorByTypes (facilities) {
    return facilities.reduce((acc, {type, floor}) => {

      const typeFloors = acc[type];
      if (!acc[type]) {
        acc[type] = [floor];
      }
      else if (!typeFloors.includes(floor)) {
        typeFloors.push(floor);
      }
      return acc;
    }, {});
  }

  _getClosestByTypes () {
    const results = this.types.map(type => {
      const item = this.searchItems.find(x => x.type == type);
      const { id } = typeToServiceType(type);
      return item.combine({ id, type: 'facility', ref: { type } });
    });
    return Promise.resolve(results);
  }

}
